import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';

// Ported 1:1 from the prototype `.dot` status indicator.
const pulse = "x1qebh90-B";
export const styles = {
  base: {
    kzqmXN: "xci0xqf",
    kZKoxP: "x1hagigm",
    kaIpWk: "xoy5co8",
    k1xSpc: "x1rg5ohu",
    kmuXW: "x2lah0s",
    $$css: true
  },
  on: {
    kWkggS: "xlvhwkj",
    kGVxlE: "xc77w73",
    $$css: true
  },
  off: {
    kWkggS: "x11bye3y",
    $$css: true
  },
  warn: {
    kWkggS: "x7dh1j1",
    $$css: true
  },
  err: {
    kWkggS: "x4qlrbh",
    kKVMdj: "xvp9s6x",
    k44tkh: "x18hd8ej",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  ok: {
    kWkggS: "xlvhwkj",
    kGVxlE: "xc77w73",
    kKVMdj: "xvp9s6x x1aquc0h",
    k44tkh: "x18hd8ej",
    ko0y90: "xa4qsjk",
    $$css: true
  }
};